import React from "react";
import useHover from "../../hooks/useHover";
import { openHelpPlayer } from "./HelpPlayerModal";

/**
 * Shared help icon. Opens the Scrlr help player for one or more labels.
 * Pass no labels to open the full help set. `visible` controls the hover reveal.
 */
export const HelpIcon = ({ label, labels, visible = true, style, className }) => {
  const names = labels || (label ? [label] : undefined);

  return (
    <img
      className={className}
      src="/icons8-help-96.png"
      alt="Help"
      title="Help"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        openHelpPlayer(names);
      }}
      style={{
        position: "absolute",
        width: 22,
        height: 22,
        padding: 6,
        boxSizing: "content-box",
        cursor: "pointer",
        opacity: visible ? 0.6 : 0,
        transition: "opacity 0.2s ease",
        zIndex: 5,
        pointerEvents: visible ? "auto" : "none",
        ...style,
      }}
    />
  );
};

/**
 * Hover-reveal help icon. Wraps children so the icon appears when the control is hovered.
 */
const HelpIconButton = ({ label, labels, children, iconStyle, wrapperStyle, className }) => {
  const [hoverRef, isHovered] = useHover();

  return (
    <div
      ref={hoverRef}
      className={className}
      style={{ display: "inline-block", ...wrapperStyle, position: "relative" }}
    >
      {children}
      <HelpIcon label={label} labels={labels} visible={isHovered} style={iconStyle} />
    </div>
  );
};

export default HelpIconButton;
